import { useMemo } from 'react';
import { CreateEntityButtonConfig } from 'record-it-components/pageContentLayout/ManageEntitiesContentLayout/ManageEntitiesContentLayout';

export function useEmptyCreateEntityButtonConfig({
  onCreateEntity,
  text,
  visible
}: UseEmptyCreateEntityButtonConfigOptions): CreateEntityButtonConfig<never> {
  return useMemo(() => {
    return {
      text,
      onCreateEntity,
      visible: visible !== false,
      dropdownItems: [],
      getDropdownItemDisplayText: () => '',
      getDropdownItemKey: () => ''
    };
  }, [text, visible, onCreateEntity]);
}

export type UseEmptyCreateEntityButtonConfigOptions = {
  text: string;
  /** default: true */
  visible?: boolean;
  onCreateEntity: () => void;
};
